import axios from "axios";
import { API_R3API_ODOO_INVOICE_LIST_URI } from "../Context/Constants";
import { getAuthRequestContext, getLoggedInUserEmail } from "./authRequest";

export const normalizeInvoiceList = (responseData) => {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.filter((item) => item && item.filename);
  }

  if (typeof responseData === "object") {
    return Object.keys(responseData)
      .sort((a, b) => Number(a) - Number(b))
      .map((key) => responseData[key])
      .filter((item) => item && typeof item === "object" && item.filename);
  }

  return [];
};

export const getInvoiceList = async (email, headers) => {
  const loginUEmail = email;
  const loginUserLowerEmail = loginUEmail.replace(/[_@.]/g, "-");
  const USER_BUCKET_NAME = loginUserLowerEmail.toLowerCase();

  const resp = await axios.get(
    API_R3API_ODOO_INVOICE_LIST_URI,
    {
      params: {
        action: "getinvoicelist",
        domain: process.env.REACT_APP_DOMAIN_PARAM,
        bucketname: USER_BUCKET_NAME,
        filter: `${loginUEmail}/Odoo/R3apiInvoices/`
      },
      headers
    }
  );

  console.log("getInvoiceList:", resp.data);
  return resp.data;
};

export const fetchInvoiceListForCurrentUser = async () => {
  const { email, headers } = await getAuthRequestContext();
  const data = await getInvoiceList(email, headers);
  return normalizeInvoiceList(data);
};

export const downloadInvoiceFile = async (filename, folderpath) => {
  const userInfo = await getLoggedInUserEmail();
  const { headers } = await getAuthRequestContext();
  const loginUEmail = userInfo.email;
  const loginUserLowerEmail = loginUEmail.replace(/[_@.]/g, "-");
  const USER_BUCKET_NAME = loginUserLowerEmail.toLowerCase();
  try {
    const response = await axios.post(
      API_R3API_ODOO_INVOICE_LIST_URI,
      {
        action: "download",
        domain: process.env.REACT_APP_DOMAIN_PARAM,
        bucketname: USER_BUCKET_NAME,
        folderpath,
        filename,
        email: userInfo.email
      },
      {
        headers,
        responseType: "text"
      }
    );

    console.log("Download response status:", response.status);
    console.log("Base64 length:", response.data.length);
    console.log("Base64 start:", response.data.substring(0, 30));

    // Base64 -> binary
    const byteCharacters = atob(response.data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    // Binary -> PDF Blob
    const pdfBlob = new Blob(
      [byteArray],
      { type: "application/pdf" }
    );

    // Download
    const url = window.URL.createObjectURL(pdfBlob);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;

    document.body.appendChild(link);
    link.click();

    link.remove();

    window.URL.revokeObjectURL(url);
    return response;

  } catch (error) {
    console.error("Invoice download error:", error);
  }

  
};
